module.exports = __webpack_public_path__ + "img/2-8-2.0b92d53b.png";